import HighlightedTable, {
	HighlightedTableContent,
} from "../../../../common/HighlightedTable/HighlightedTable";
import MarkdownRenderer from "../../../../common/MarkdownRenderer/MarkdownRenderer";
import "./Comparison.scss";

const comparisonColumns = [
	"core-focus",
	"accountability",
	"cost-control",
	"progress-visibility",
	"design",
] as const;

export type ColumnHeader = (typeof comparisonColumns)[number];

const Comparison = ({
	sectionContent,
	isMobile,
}: {
	sectionContent: HighlightedTableContent<ColumnHeader>;
	isMobile: boolean;
}) => {
	return (
		<section className="comparison background-container--gradient">
			<div className="content-container">
				<MarkdownRenderer>{sectionContent.title}</MarkdownRenderer>
				<MarkdownRenderer>{sectionContent.content}</MarkdownRenderer>
				{isMobile ? (
					[sectionContent.otherApps!, sectionContent.flyORKA].map((column) => {
						return (
							<HighlightedTable
								key={column.title}
								columnsHeaders={sectionContent.columnsHeaders}
								columns={[column]}
								className={
									column.title === "FlyORKA"
										? "table--recommended"
										: "table--others"
								}
								isMobile
							/>
						);
					})
				) : (
					<HighlightedTable
						columnsHeaders={sectionContent.columnsHeaders}
						columns={[sectionContent.otherApps!, sectionContent.flyORKA]}
					/>
				)}
			</div>
		</section>
	);
};

export default Comparison;
